export default __webpack_public_path__ + "static/media/work_with_households_icon_active.e144d77a.svg";